
import { Component, Mixins } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import * as modals from "@/lib/modals";
import notifications from "@/lib/notifications";

@Component({
  name: modals.resolveMissingInventoryItemModal
})
export default class ResolveMissingInventoryItemModal extends Mixins(mixin) {
  inventoryModuleState: InventoryModule = getModule(InventoryModule);
  resolveExplanation: string = '';

  resolveExplanationState() {
    return !this.resolveExplanation || this.resolveExplanation == '' ? false : true;
  }


  validateForm() {
    if(this.resolveExplanationState() === false) return false;
    return true;
  }

  async resolve() {
    if(!this.validateForm()) return;

    this.isLoading = true;
  
    if(this.selectedItems && this.selectedItems.length == 1)
    {
      try {
        let request = {
          id: this.selectedItems[0].id,
          resolveExplanation: this.resolveExplanation
        };
        await this.inventoryModuleState.resolveMissingInventoryItem(request);
        notifications.success("Resolved Missing Item", "Missing inventory item status successfully resolved.");
        await this.inventoryModuleState.loadInventoryItem(this.selectedItems[0].id);
      } catch (error) {
        notifications.error("Resolving Missing Item", "Failed to resolve missing inventory item status.", error);
      }
    }
    
    this.hideModal();
  }

  reset() {
    this.resolveExplanation = '';
  }
}
